import React from 'react';
import 'react-swipeable-list/dist/styles.css';
import MobileMessage from './MobileMessage.js';

const MobileMessageWrapper = ({ message, onClick, onReadOrUnreadToggleClick }) => {
  return <MobileMessage message={message} onClick={onClick} onReadOrUnreadToggleClick={onReadOrUnreadToggleClick} />;
};

export default MobileMessageWrapper;
